/**
 * Job notes API calls.
 */

import client from './client';

export async function fetchJobNotes(jobId) {
  const { data } = await client.get('/jobs/notes/', { params: { job: jobId, page_size: 200 } });
  return data.data || data.results || [];
}

export async function createJobNote(payload) {
  const { data } = await client.post('/jobs/notes/', payload);
  return data.data || data;
}

export async function updateJobNote(id, payload) {
  const { data } = await client.patch(`/jobs/notes/${id}/`, payload);
  return data.data || data;
}

export async function deleteJobNote(id) {
  await client.delete(`/jobs/notes/${id}/`);
}
